import './index.css';
import img1 from '../../../src/images/Left3.svg';
import img2 from '../../../src/images/Step 03.svg';
import img3 from '../../../src/images/cross-icon.svg';
import img4 from '../../../src/images/analysis-profile.svg';
import img5 from '../../../src/images/insights1.svg';
import img6 from '../../../src/images/insights2.svg'
import img7 from '../../../src/images/insights3.svg'
import img8 from '../../../src/images/insights4.svg'
import img9 from '../../../src/images/insights5.svg'
import img10 from '../../../src/images/insights6.svg'
import img11 from '../../../src/images/insights7.svg'
import img12 from '../../../src/images/Chart.svg'
import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';




function AIAnalysis3() {
    const navigate = useNavigate();
    const [cards, setCards] = useState([]);
    const [activeButton, setActiveButton] = useState(null); // State to store active button index


    // Handler to set the active button index
    const handleButtonClick = (index) => {
        setActiveButton(index);
    };



    const navigateTo = (path) => {
        navigate(path);
    };
    return (
        <>
            <div className="dashboard_container ai-analysis-container">
                <div className="analysis_container">
                    <div className='analysis_navbar'>
                        <div onClick={() => navigateTo('/aianalysis2')}>
                            <img src={img1} alt="" />
                        </div>
                        <div>
                            <h3>AI Analysis Results</h3>
                        </div>
                        <div onClick={() => navigateTo('/')}>
                            <img src={img3} alt="" />
                        </div>
                    </div>
                    <div className='step_image'>
                        <img src={img2} alt="" />
                    </div>
                    <div className='profile_wrapper'>
                        <div className='profile-text'>
                            <div><img src={img4} alt="" /></div>
                            <div>
                                <h2>Victor Borg</h2>
                                <h3>Age: 35, Type 1<br />Last lab: 20 Sept, 2024</h3>
                            </div>
                        </div>
                        <div className='analysis_profile_btn'>
                            <button>High</button>
                        </div>
                    </div>
                    <div className='quick-insights-heading'>
                        <h2>Quick insights</h2>
                    </div>
                    <div className='cards_slider analysis-card-slider'>
                        <div className='cards_container'>
                            <div className='cards_wrapper ai-cards-wrapper'>
                                <img src={img5} alt="Analysis Icon" />
                                <h2>Avg glucose<br /><span>138 mg/dL</span></h2>
                                <div className='bottom_line'></div>
                                <div className='card_wrapper_bottom'>
                                    <div className='pending_text'>
                                        <h5>Reduced</h5>
                                        <h6>27 mg/dL</h6>
                                    </div>
                                    <div className='confirmed_text'>
                                        <h5>Decrease</h5>
                                        <h6>16%</h6>
                                    </div>
                                </div>
                            </div>
                            <div className='cards_wrapper ai-cards-wrapper'>
                                <img src={img6} alt="Appointments Icon" />
                                <h2>Insulin levels<br /><span>32 units</span></h2>
                                <div className='bottom_line'></div>
                                <div className='card_wrapper_bottom'>
                                    <div className='pending_text'>
                                        <h5>Basal</h5>
                                        <h6>24u</h6>
                                    </div>
                                    <div className='confirmed_text'>
                                        <h5>Bolus</h5>
                                        <h6>8u</h6>
                                    </div>
                                </div>
                            </div>
                            <div className='cards_wrapper ai-cards-wrapper'>
                                <img src={img7} alt="Appointments Icon" />
                                <h2>Time in Range<br /><span>32 units</span></h2>
                                <div className='bottom_line'></div>
                                <div className='card_wrapper_bottom'>
                                    <div className='pending_text'>
                                        <h5>Basal</h5>
                                        <h6>24u</h6>
                                    </div>
                                    <div className='confirmed_text'>
                                        <h5>Bolus</h5>
                                        <h6>8u</h6>
                                    </div>
                                </div>
                            </div>
                            <div className='cards_wrapper ai-cards-wrapper'>
                                <img src={img8} alt="Appointments Icon" />
                                <h2>Events<br /><span>32 units</span></h2>
                                <div className='bottom_line'></div>
                                <div className='card_wrapper_bottom'>
                                    <div className='pending_text'>
                                        <h5>Basal</h5>
                                        <h6>24u</h6>
                                    </div>
                                    <div className='confirmed_text'>
                                        <h5>Bolus</h5>
                                        <h6>8u</h6>
                                    </div>
                                </div>
                            </div>
                            <div className='cards_wrapper ai-cards-wrapper'>
                                <img src={img9} alt="Appointments Icon" />
                                <h2>Meal Impact<br /><span>32 units</span></h2>
                                <div className='bottom_line'></div>
                                <div className='card_wrapper_bottom'>
                                    <div className='pending_text'>
                                        <h5>Basal</h5>
                                        <h6>24u</h6>
                                    </div>
                                    <div className='confirmed_text'>
                                        <h5>Bolus</h5>
                                        <h6>8u</h6>
                                    </div>
                                </div>
                            </div>
                            <div className='cards_wrapper ai-cards-wrapper'>
                                <img src={img10} alt="Appointments Icon" />
                                <h2>Exercise Effect<br /><span>32 units</span></h2>
                                <div className='bottom_line'></div>
                                <div className='card_wrapper_bottom'>
                                    <div className='pending_text'>
                                        <h5>Basal</h5>
                                        <h6>24u</h6>
                                    </div>
                                    <div className='confirmed_text'>
                                        <h5>Bolus</h5>
                                        <h6>8u</h6>
                                    </div>
                                </div>
                            </div>
                            <div className='cards_wrapper ai-cards-wrapper'>
                                <img src={img11} alt="Appointments Icon" />
                                <h2>Diet Balance<br /><span>32 units</span></h2>
                                <div className='bottom_line'></div>
                                <div className='card_wrapper_bottom'>
                                    <div className='pending_text'>
                                        <h5>Basal</h5>
                                        <h6>24u</h6>
                                    </div>
                                    <div className='confirmed_text'>
                                        <h5>Bolus</h5>
                                        <h6>8u</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='ai-analysis-buttons'>
                        <h1>Insulin intake</h1>
                        <div className='ai-analysis-wrapper'>
                            <div className={`aianalysis-btn1 ${activeButton === 1 ? 'aianalysis-black-btn' : ''}`} ><button onClick={() => handleButtonClick(1)}>Save</button></div>
                            <div className={`aianalysis-btn2 ${activeButton === 2 ? 'aianalysis-black-btn' : ''}`} ><button onClick={() => handleButtonClick(2)}>Send Report</button></div>
                            <div className={`aianalysis-btn3 ${activeButton === 3 ? 'aianalysis-black-btn' : ''}`} ><button onClick={() => handleButtonClick(3)}>Call</button></div>
                            <div className={`aianalysis-btn3 ${activeButton === 4 ? 'aianalysis-black-btn' : ''}`} ><button onClick={() => handleButtonClick(4)}>SMS</button></div>
                        </div>
                    </div>

                    <div className='analysis-chart'>
                        <img src={img12} alt="" />
                    </div>
                </div>

            </div>
            <div className='analysis-footer-wrapper'>
                <div className='ai-analysis-footer'>
                    <div className='ai-analysis-footer-btn'>AI Voice Command</div>
                    <p>Speak your choice (e.g., “Analyze individual patient data” or “Group trends analysis”).</p>
                </div>
            </div>
        </>

    );
}

export default AIAnalysis3;
